import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DeliveryMethodButtonList from './DeliveryMethodButtonList';
import VerifyPhone from './VerifyPhone';
import VerifyPassword from './VerifyPassword';

const propTypes = {
    /**
     * error messages that will be provided in the
     * case of an incorrect password or verification code
     */
    otpErrorMessage: PropTypes.string,
    loginErrorMessage: PropTypes.string,

    /**
     * render additional options based on device trust
     */
    isTrustedDevice: PropTypes.bool.isRequired,

    /**
     * the html form field name for the delivery method (`deliveryMethod`)
     */
    groupName: PropTypes.string.isRequired,

    /**
     * the value of the default delivery method to display
     */
    currentMethod: PropTypes.string,

    /**
     * the Name of the default selected phone number
     */
    currentPhone: PropTypes.string,

    /**
     * delivery choices ({ id, label, value }) rendered as button list (`asc-btn-list`).
     * value may be sms, voice, or password (trusted devices).
     */
    deliveryMethods: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired
        }).isRequired
    ).isRequired,

    /**
     * array of phone numbers
     */
    phoneNumbers: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired
        }).isRequired
    )
};
const defaultProps = {
    phoneNumbers: []
};

function normalizePhoneNumbers(phoneNumbers) {
    return Array.isArray(phoneNumbers) ? phoneNumbers : [];
}

class VerificationMethod extends Component {
    constructor(props) {
        super(props);

        const phoneNumbers = normalizePhoneNumbers(props.phoneNumbers);
        const defaultPhone = phoneNumbers[0]?.name ?? '';

        this.state = {
            currentMethod: props.currentMethod
                ? this.getCurrentMethod(props.currentMethod)
                : props.deliveryMethods[0],
            currentPhone: props.currentPhone || defaultPhone
        };
    }

    getCurrentMethod = methodValue => {
        return this.props.deliveryMethods.find(method => method.value === methodValue);
    };

    changeHandler = event => {
        // change displayed form field based on radio button
        this.setState({ currentMethod: this.getCurrentMethod(event.target.value) });
    };

    render() {
        const { isTrustedDevice, deliveryMethods, loginErrorMessage, otpErrorMessage, groupName } =
            this.props;
        const phoneNumbers = normalizePhoneNumbers(this.props.phoneNumbers);
        const { currentMethod, currentPhone } = this.state;
        const selectMethodText = `Choose whether you'd like us to text you or call you with your verification code${
            isTrustedDevice ? ' or just use your password' : ''
        }`;

        return (
            <div>
                <div className="text--center">
                    <div>
                        <span className="asc-icon asc-icon--lock mfa-header-icon">
                            <span className="asc-hidden">Padlock Icon</span>
                        </span>
                    </div>
                    <h2 className="asc-h3">Select Verification Method</h2>
                    <p>{selectMethodText}</p>
                </div>

                <div className="text--center">
                    <DeliveryMethodButtonList
                        groupName={groupName}
                        currentValue={currentMethod.value}
                        onChange={this.changeHandler}
                        options={deliveryMethods}
                        ariaLabel="Select verification method"
                    />
                    {(currentMethod.value === 'voice' || currentMethod.value === 'sms') &&
                        phoneNumbers.length > 0 && (
                            <VerifyPhone
                                otpErrorMessage={otpErrorMessage}
                                checkedPhone={currentPhone}
                                phoneNumbers={phoneNumbers}
                            />
                        )}
                    {currentMethod.value === 'password' && (
                        <VerifyPassword loginErrorMessage={loginErrorMessage} />
                    )}
                </div>
            </div>
        );
    }
}

VerificationMethod.propTypes = propTypes;
VerificationMethod.defaultProps = defaultProps;
export default VerificationMethod;
